import * as VueRouter from "vue-router";

import Layout from "@/components/Layout/Layout";
import { isAuthenticated } from "@/auth";

const routes = [
  {
    path: "/login",
    component: () => import("./Login"),
    name: "login",
  },
  {
    path: "/login-form",
    component: () => import("./LoginForm"),
    name: "login-form",
  },
  {
    path: "/",
    component: Layout,
    beforeEnter: async (to, from, next) => {
      if (!isAuthenticated()) next({ name: "login-form" });
      else {
        next();
      }
    },
    children: [
      {
        path: "",
        redirect: "/tplotworks",
      },
      {
        path: "tplotworks",
        name: "tplotworks",
        component: () => import("@/TplotworksApp"),
      },
      {
        path: "tbuildingworks",
        name: "tbuildingworks",
        component: () => import("@/TbuildingworksApp"),
      },
      {
        path: "types",
        name: "types",
        component: () => import("@/TypesApp"),
      },
      {
        path: "admin",
        name: "admin",
        component: () => import("@/AdminApp"),
      },
    ],
  },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
});

export default router;
